import { Component, Input } from '@angular/core';
import { AvanoButtonBarButtonDetails } from '../avano-button-bar.common';

@Component({
  selector: 'avano-button-bar-button',
  templateUrl: './avano-button-bar-button.component.html',
  styleUrls: ['./avano-button-bar-button.component.scss']
})
export class AvanoButtonBarButtonComponent {
  @Input() buttonDetails: AvanoButtonBarButtonDetails;

  onActionTriggered(clickedAvanoButton: AvanoButtonBarButtonDetails) {
    if (clickedAvanoButton.action) {
      clickedAvanoButton.action();
    }
  }
}
